// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__AaTrq","isLink":"Card_isLink___TUSU","noBorderRadius":"Card_noBorderRadius__4l0ut"};